import { render, staticRenderFns } from "./install-antifog-3s.vue?vue&type=template&id=12521930&"
import script from "./install-antifog-3s.vue?vue&type=script&lang=ts&"
export * from "./install-antifog-3s.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports